import { render, staticRenderFns } from "./default.vue?vue&type=template&id=88b7f204&scoped=true&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"
import style0 from "styles/pages/health-file/index.less?vue&type=style&index=0&lang=less&"
import style1 from "styles/components/header.less?vue&type=style&index=1&lang=less&"
import style2 from "./default.vue?vue&type=style&index=2&lang=css&"
import style3 from "./default.vue?vue&type=style&index=3&id=88b7f204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b7f204",
  null
  
)

export default component.exports